import { generateMeasuresFromDimensions } from './generate-measures.js';
import { meetingBodyLink } from './links.js';
import { seatTypeValueLabels } from './value-labels.js';
const aggregatableDimensions = {
    'meeting_body_seats.term_length': {
        aggregations: ['avg', 'max'],
        label: 'Term Length',
        type: 'number',
    },
    'meeting_body_seats.term_limit': {
        aggregations: ['avg'],
        label: 'Term Limit',
        type: 'number',
    },
};
export const meetingBodySeatsCube = {
    category: 'Meeting Bodies',
    description: 'Seats on meeting bodies with type, term limits, vacancy status, and application settings.',
    label: 'Meeting Body Seats',
    measures: {
        'meeting_body_seats.count': { label: 'Count', type: 'number' },
        ...generateMeasuresFromDimensions(aggregatableDimensions),
        'meeting_body_seats.vacant_count': { label: 'Vacant Seats', type: 'number' },
    },
    dimensions: {
        ...aggregatableDimensions,
        'meeting_bodies.name': { label: 'Meeting Body', link: meetingBodyLink, type: 'string' },
        'meeting_body_seats.allow_applications': { label: 'Allow Applications', type: 'boolean' },
        'meeting_body_seats.appointed_by': { label: 'Appointed By', type: 'string' },
        'meeting_body_seats.days_vacant': { label: 'Days Vacant', type: 'number' },
        'meeting_body_seats.has_term_duration': { label: 'Has Term Duration', type: 'boolean' },
        'meeting_body_seats.has_term_limit': { label: 'Has Term Limit', type: 'boolean' },
        'meeting_body_seats.is_vacant': { label: 'Is Vacant', type: 'boolean' },
        'meeting_body_seats.number': { label: 'Number', type: 'number' },
        'meeting_body_seats.requirements': { label: 'Requirements', narrative: true, type: 'string' },
        'meeting_body_seats.title': { label: 'Title', type: 'string' },
        'meeting_body_seats.type': { label: 'Type', type: 'string', valueLabels: seatTypeValueLabels },
    },
    timeDimensions: {
        'meeting_body_seats.created_at': { label: 'Created At', type: 'date' },
        'meeting_body_seats.term_start': { label: 'Term Start', type: 'date' },
        'meeting_body_seats.updated_at': { label: 'Updated At', type: 'date' },
        'meeting_body_seats.vacant_since': { label: 'Vacant Since', type: 'date' },
    },
};
